








import { Vue, Component } from "vue-property-decorator";
import CommonButton from "./CommonButton.vue"

@Component({ components: { CommonButton }})
export default class DevicesTestButton extends Vue {
}
